import { RemoteDataPage } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';

import { ContactOutput } from 'contact/model/contact.output';
import { FetchContactsQuery } from 'contact/query/fetch-contacts.query';
import { FetchKanbanContactsQuery } from 'contact/query/fetch-kanban-contacts.query';

import { AddContactColumnCmd } from '../command/add-contact-column.cmd';
import { RemoveContactColumnCmd } from '../command/remove-contact-column.cmd';
import { FetchProviderContactsQuery } from '../query/fetch-provider-contacts.query';

export abstract class ContactApiPort {
	public abstract fetchContacts(
		query?: FetchContactsQuery
	): Observable<ContactOutput[]>;

	public abstract fetchKanbanContacts(
		query: FetchKanbanContactsQuery
	): Observable<ContactOutput[]>;

	public abstract fetchProviderContacts(
		query: FetchProviderContactsQuery
	): Promise<RemoteDataPage<ContactOutput>>;

	public abstract removeContactColumn(
		cmd: RemoveContactColumnCmd
	): Promise<ContactOutput>;

	public abstract addContactColumn(
		cmd: AddContactColumnCmd
	): Promise<ContactOutput>;

	public abstract fetchContactsByIds(ids: string[]): Promise<ContactOutput[]>;

	public abstract deleteContact(id: string): Promise<string>;

	public abstract fetchContactById(id: string): Promise<ContactOutput>;
}
